import { render, staticRenderFns } from "./SubmissionApplyTestPackage.vue?vue&type=template&id=0e53cc54"
import script from "./SubmissionApplyTestPackage.vue?vue&type=script&lang=js"
export * from "./SubmissionApplyTestPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports